// extracted by mini-css-extract-plugin
export var emptyMessage = "promo-page-module--emptyMessage--ace84";
export var headline = "promo-page-module--headline--cf945";
export var item = "promo-page-module--item--69555";
export var itemFew = "promo-page-module--itemFew--77264";
export var itemList = "promo-page-module--itemList--e7d7b";
export var itemListFew = "promo-page-module--itemListFew--73c1c";
export var promoPage = "promo-page-module--promoPage--5379d";
export var selectbuttons = "promo-page-module--selectbuttons--e1330";
export var subcopy = "promo-page-module--subcopy--f0551";